import { environment } from 'nsdi-volto-frontend/config/environments';

/**
 * Collections Block Schema
 *
 * Defines the editable fields for the Collections Block in the Volto sidebar.
 */

const collectionItemSchema = {
  title: 'Collection Item',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'link', 'itemCount'],
    },
  ],
  properties: {
    title: {
      title: 'Collection Title',
      description: 'The name of the collection',
      type: 'string',
    },
    link: {
      title: 'Search URL/Query',
      description:
        'Query parameters (e.g., fq=grp_Catalog:NASA&sort=score) or full URL. Query params are appended to the Search Results Base URL.',
      type: 'string',
    },
    itemCount: {
      title: 'Item Count',
      description:
        'Auto-fetched from Voyager API using base URL + query. Set manually to override.',
      type: 'number',
      default: 0,
    },
  },
  required: ['title', 'link'],
};

const CollectionsBlockSchema = {
  title: 'Collections',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'showItemCount', 'maxItemsToShow', 'fetchDynamic'],
    },
    {
      id: 'api',
      title: 'API Configuration',
      fields: ['voyagerConfigId'],
    },
    {
      id: 'collections',
      title: 'Static Collections',
      fields: ['searchResultsBaseUrl', 'voyagerBaseUrl', 'collections'],
    },
    {
      id: 'styling',
      title: 'Styling',
      fields: ['backgroundColor', 'titleColor'],
    },
  ],
  properties: {
    title: {
      title: 'Block Title',
      description: 'The title displayed above the collections list',
      type: 'string',
      default: 'Collections',
    },
    showItemCount: {
      title: 'Show Item Count',
      description: 'Display the number of items for each collection',
      type: 'boolean',
      default: true,
    },
    maxItemsToShow: {
      title: 'Maximum Items to Show',
      description: 'Maximum number of collections to display',
      type: 'number',
      default: 10,
      minimum: 1,
      maximum: 50,
    },
    fetchDynamic: {
      title: 'Fetch Dynamic Counts',
      description:
        'Fetch live item counts from the Voyager API. If disabled, uses static values.',
      type: 'boolean',
      default: false,
    },
    voyagerBaseUrl: {
      title: 'Voyager API Base URL',
      description: 'Base URL for the Voyager Search API',
      type: 'string',
      default: environment.voyager.baseUrl,
    },
    voyagerConfigId: {
      title: 'Voyager Config ID',
      description: 'Configuration ID for the Voyager instance',
      type: 'string',
      default: environment.voyager.configId,
    },
    searchResultsBaseUrl: {
      title: 'Search Results Base URL',
      description:
        'Base URL for search results page. Collection links will be appended to this URL (e.g., https://ogc-sdi.voyagersearch.com/navigo/search)',
      type: 'string',
      default: environment.voyager.searchUrl,
    },
    collections: {
      title: 'Catalog Collections',
      description:
        'Add collections with Voyager search URLs. Can be full URLs or query strings (e.g., ?fq=grp_Catalog:NASA...).',
      type: 'array',
      items: {
        type: 'object',
        schema: collectionItemSchema,
      },
      widget: 'object_list',
      schema: collectionItemSchema,
    },
    backgroundColor: {
      title: 'Background Color',
      description: 'Background color of the collections block (e.g., #ffffff)',
      type: 'string',
      default: '#ffffff',
    },
    titleColor: {
      title: 'Title Color',
      description: 'Color of the block title (e.g., #0066cc)',
      type: 'string',
      default: '#0066cc',
    },
  },
  required: [],
};

export default CollectionsBlockSchema;
